<template>
  <b-form @submit.prevent="openModalConfirm">
    <div class="form-parameter-wrapper">
      <b-form-group label-cols-sm="12" label-cols-lg="3" label="Limit Kas Kecil Kelas 1" label-align="left">
        <b-row class="parameter-wrapper">
          <b-col>
            <b-input-group prepend="Rp">
              <b-form-input v-model="kasKecilInput.LIMIT_KAS_KECIL_KELAS_1" name="limitKasKecilKelas1" required />
            </b-input-group>
            <span class="smallText text-muted">Limit kas kecil untuk cabang kelas 1.</span>
          </b-col>
        </b-row>
      </b-form-group>
      <b-form-group label-cols-sm="12" label-cols-lg="3" label="Limit Kas Kecil Kelas 2" label-align="left">
        <b-row class="parameter-wrapper">
          <b-col>
            <b-input-group prepend="Rp">
              <b-form-input v-model="kasKecilInput.LIMIT_KAS_KECIL_KELAS_2" name="limitKasKecilKelas2" required />
            </b-input-group>
            <span class="smallText text-muted">Limit kas kecil untuk cabang kelas 2.</span>
          </b-col>
        </b-row>
      </b-form-group>
      <b-form-group label-cols-sm="12" label-cols-lg="3" label="Limit Kas Kecil Kelas 3" label-align="left">
        <b-row class="parameter-wrapper">
          <b-col>
            <b-input-group prepend="Rp">
              <b-form-input v-model="kasKecilInput.LIMIT_KAS_KECIL_KELAS_3" name="limitKasKecilKelas3" required />
            </b-input-group>
            <span class="smallText text-muted">Limit kas kecil untuk cabang kelas 3.</span>
          </b-col>
        </b-row>
      </b-form-group>
      <b-form-group label-cols-sm="12" label-cols-lg="3" label="Tambahan Kas Kecil Untuk KCU" label-align="left">
        <b-row class="parameter-wrapper">
          <b-col>
            <b-input-group prepend="Rp">
              <b-form-input v-model="kasKecilInput.TAMBAHAN_KAS_KECIL_UNTUK_KCU" name="tambahanKasKecilUntukKcu" required />
            </b-input-group>
            <span class="smallText text-muted">Tambahan limit kas kecil untuk cabang KCU.</span>
          </b-col>
        </b-row>
      </b-form-group>
    </div>
    <div class="form-wrapper-btn submit-btn-wrapper">
      <b-button type="submit" name="parameterUpdateBtn" variant="pgiBtn">Update</b-button>
    </div>
    <ModalConfirm
      id="modal-edit-kas-kecil"
      title="Confirm Edit Parameter Kas Kecil"
      :isSubmitting="isSubmitting"
      desc="Apakah anda yakin untuk mengubah parameter kas kecil ini?"
      @submit="onSubmit"
    />
  </b-form>
</template>

<script>
export default {
  name: "parameter-kas-kecil",
  props: {
    kasKecilInput: { type: Object, required: true },
  },
  data() {
    return {
      isSubmitting: false,
      newData: {},
    };
  },
  watch: {
    "kasKecilInput.LIMIT_KAS_KECIL_KELAS_1": function (newValue) {
      this.formatInput("LIMIT_KAS_KECIL_KELAS_1", newValue);
    },
    "kasKecilInput.LIMIT_KAS_KECIL_KELAS_2": function (newValue) {
      this.formatInput("LIMIT_KAS_KECIL_KELAS_2", newValue);
    },
    "kasKecilInput.LIMIT_KAS_KECIL_KELAS_3": function (newValue) {
      this.formatInput("LIMIT_KAS_KECIL_KELAS_3", newValue);
    },
    "kasKecilInput.TAMBAHAN_KAS_KECIL_UNTUK_KCU": function (newValue) {
      this.formatInput("TAMBAHAN_KAS_KECIL_UNTUK_KCU", newValue);
    },
  },
  methods: {
    formatInput(key, value) {
      const result = String(value || "")
        .replace(/\D/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      if (value === result) return;
      this.$nextTick(() => this.kasKecilInput[key] = result);
    },
    onSubmit() {
      this.newData = JSON.parse(JSON.stringify(this.kasKecilInput));
      this.newData.LIMIT_KAS_KECIL_KELAS_1 = this.$helper.removeThousandSeparator(this.newData.LIMIT_KAS_KECIL_KELAS_1);
      this.newData.LIMIT_KAS_KECIL_KELAS_2 = this.$helper.removeThousandSeparator(this.newData.LIMIT_KAS_KECIL_KELAS_2);
      this.newData.LIMIT_KAS_KECIL_KELAS_3 = this.$helper.removeThousandSeparator(this.newData.LIMIT_KAS_KECIL_KELAS_3);
      this.newData.TAMBAHAN_KAS_KECIL_UNTUK_KCU = this.$helper.removeThousandSeparator(this.newData.TAMBAHAN_KAS_KECIL_UNTUK_KCU);

      let payload = new FormData();
      for (let [key, value] of Object.entries(this.newData)) {
        payload.append("name", key);
        payload.append("value", value);
      }

      this.isSubmitting = true;
      this.$axios.post("parameter/update/", payload).then(() => {
        this.$helper.toastSucc(this, "Parameter Kas Kecil telah berhasil diubah!");
        this.$bvModal.hide("modal-edit-kas-kecil");
      })
        .catch(error => {
          this.$helper.parseError(this, error);
        })
        .finally(() => {
          this.isSubmitting = false;
        });
    },
    openModalConfirm() {
      this.$bvModal.show("modal-edit-kas-kecil");
    },
  },
};
</script>
